import I18n from 'I18n';
import { fetchBuyerOverridesPreviewSubtotals, fetchBuyerOverridesSubtotals } from '../../data/BuyerOverridesApi';
import { setDiscountCodeErrorMessage, setDiscountAmount, setIsDiscountPending } from '../../state/DiscountCode/discountCodeSlice';
import { OPEN } from 'customer-data-objects/ticket/TicketStageStatusOptions';
import updateCheckoutSessionSubtotals from '../../utils/updateCheckoutSessionSubtotals';
// @ts-ignore Untyped module
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';
import { setErrorMessages } from '../../state/errorMessagesSlice';
import { isFutureBilledSubtotal } from '../../types/utils/typeguards';
const handleBelowMinimumTotal = ({
  reduxDispatch,
  nativeCurrencySymbol,
  minimumAmount,
  messageKey
}) => {
  reduxDispatch(setIsDiscountPending(false));
  const message = I18n.text(messageKey, {
    currencySymbol: nativeCurrencySymbol,
    stripeMinimumRequired: (minimumAmount !== null && minimumAmount !== void 0 ? minimumAmount : 0.01).toFixed(2)
  });
  reduxDispatch(setDiscountCodeErrorMessage(message));
};
const isBelowMinimumOrZero = (amount, minimumAmount) => amount <= 0 || !!minimumAmount && amount < minimumAmount;
const hasFuturePayments = recurringSubtotal => {
  const {
    numPayments
  } = recurringSubtotal.recurringBillingTerms;
  return isFutureBilledSubtotal(recurringSubtotal) || !!numPayments && numPayments > 1;
};
const parseDiscountCodeApplyResponseData = ({
  data,
  status,
  minimumAmount,
  client,
  reduxDispatch,
  dispatch,
  currencyCode
}) => {
  if (status === OPEN) {
    var _data$discountCodeRes;
    // When minimumAmount is unavailable (e.g. limits API failed), we can only catch <= 0.
    // Totals between $0.01 and the actual currency/payment-method minimum will still slip through in that case.
    const isFirstPaymentBelowMinimum = isBelowMinimumOrZero(data.firstPaymentTotal, minimumAmount);
    const futureRecurringSubtotals = ((_data$discountCodeRes = data.discountCodeResponse) === null || _data$discountCodeRes === void 0 || (_data$discountCodeRes = _data$discountCodeRes.checkoutSessionDiscount) === null || _data$discountCodeRes === void 0 ? void 0 : _data$discountCodeRes.durationType) === 'RECURRING' ? data.recurringSubtotals.filter(hasFuturePayments) : [];
    // A recurring discount on a checkout with nothing due now only applies to future payments, so no charge is made at checkout.
    const isRecurringDiscountWithNothingDueNow = data.firstPaymentTotal === 0 && futureRecurringSubtotals.length > 0;
    // A recurring discount applies to every future payment, so each one must still meet the minimum.
    const isFuturePaymentBelowMinimum = futureRecurringSubtotals.some(({
      total
    }) => isBelowMinimumOrZero(total, minimumAmount));
    const isDueNowBelowMinimum = !isRecurringDiscountWithNothingDueNow && isFirstPaymentBelowMinimum;
    if (isDueNowBelowMinimum || isFuturePaymentBelowMinimum) {
      handleBelowMinimumTotal({
        reduxDispatch,
        nativeCurrencySymbol: getNativeCurrencySymbol(currencyCode),
        minimumAmount,
        messageKey: isDueNowBelowMinimum ? 'payments.notSufficientTotalMessage' : 'payments.notSufficientFutureTotalMessage'
      });
    } else {
      if (data.discountCodeResponse) {
        reduxDispatch(setDiscountCodeErrorMessage(''));
        reduxDispatch(setErrorMessages({
          invalidDiscountCode: {
            isError: false
          }
        }));
        reduxDispatch(setDiscountAmount({
          discountedValue: data.oneTimeDiscountAmount ? data.oneTimeDiscountAmount : 0,
          discountedPercentage: data.discountCodeResponse.checkoutSessionDiscount.valueType === 'PERCENT' ? data.discountCodeResponse.checkoutSessionDiscount.value : 0
        }));
        dispatch({
          type: 'setIsDiscountCodeApplied',
          data: true
        });
        reduxDispatch(setIsDiscountPending(false));
        updateCheckoutSessionSubtotals(client, data);
      }
    }
  }
};
export function applyDiscount({
  checkoutSession,
  dispatch,
  reduxDispatch,
  isIframePreviewUrl,
  buyerOverrides,
  isDiscountRemoved,
  minimumAmount,
  client,
  checkoutFees,
  paymentMethod
}) {
  const {
    currencyCode,
    status,
    id: paymentSessionId,
    lineItems,
    portalId,
    adjustments
  } = checkoutSession;
  if (isIframePreviewUrl) {
    fetchBuyerOverridesPreviewSubtotals({
      buyerOverrides,
      currencyCode,
      lineItems,
      portalId,
      adjustments,
      paymentMethod,
      checkoutFees
    }).then(data => {
      if (isDiscountRemoved) {
        updateCheckoutSessionSubtotals(client, data);
        dispatch({
          type: 'setDiscountCode',
          data: ''
        });
      } else {
        parseDiscountCodeApplyResponseData({
          data,
          status,
          minimumAmount,
          client,
          dispatch,
          reduxDispatch,
          currencyCode
        });
      }
    }).catch(() => {
      reduxDispatch(setIsDiscountPending(false));
      reduxDispatch(setDiscountCodeErrorMessage(I18n.text('payments.invalidDiscountCodeMessage')));
    });
  } else {
    fetchBuyerOverridesSubtotals({
      buyerOverrides,
      paymentSessionId,
      paymentMethod
    }).then(data => {
      if (isDiscountRemoved) {
        updateCheckoutSessionSubtotals(client, data);
        dispatch({
          type: 'setDiscountCode',
          data: ''
        });
      } else {
        parseDiscountCodeApplyResponseData({
          data,
          status,
          minimumAmount,
          client,
          dispatch,
          reduxDispatch,
          currencyCode
        });
      }
    }).catch(() => {
      reduxDispatch(setIsDiscountPending(false));
      reduxDispatch(setDiscountCodeErrorMessage(I18n.text('payments.invalidDiscountCodeMessage')));
      reduxDispatch(setErrorMessages({
        invalidDiscountCode: {
          isError: true
        }
      }));
    });
  }
}